import ProcessFlowCallToAction from "~/models/processFlows/callToActions/processFlowCallToAction"
import {CallToActionType} from "~/enums/processFlows/callToActionType"
import {IProcessFlowCallToActionShowFile, IProcessFlowMappedVariable} from "~/interfaces/processFlowInterfaces"

/**
 * Show a file
 */
export default class ShowFileCallToAction extends ProcessFlowCallToAction implements IProcessFlowCallToActionShowFile {
  action_type: CallToActionType.File
  variable_reference: IProcessFlowMappedVariable

  constructor(protected _rootName: string, options: any = {}) {
    super(_rootName, options)
  }

  get hasVariableReference(): boolean {
    return this.variableReference.pathExists
  }

  get variableReference(): IProcessFlowMappedVariable {
    return this.variable_reference || this.createVariableReference()
  }

  get isValid(): boolean {
    return (!this.buttonLabelRequired || Boolean(this.button_label)) &&
      this.hasVariableReference
  }
}